import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import b from 'b_';
import Actions from '../Actions/Actions';
import Button from '../Button';
import Modal from '../Modal';
import AdminTimeoutStore from '../../stores/AdminTimeoutStore';
import Box from '../Box/Box';
import { TBody } from '../Text/Text';
import TimerSpinner from '../TimerSpinner/TimerSpinner';
import Icon from '../Icon/Icon';
import './AdminActivityModal.css';

const block = b.lock('AdminActivityModal');

class AdminActivityModal extends Component {
    static propTypes = {
        adminTimeout: AdminTimeoutStore.PropType,
    };

    renderTimer() {
        const { adminTimeout } = this.props;

        return <Fragment>
            <TimerSpinner
                totalTime={adminTimeout.timeTotal}
                currentTime={adminTimeout.timeLeft}
                className={block('ActionSectionIcon')}
                counterClockwise
            />

            <span className={block('InfoBottomText')}>
                Expires in {adminTimeout.timeLeft} Seconds
            </span>
        </Fragment>;
    }

    renderTimeout() {
        return <Fragment>
            <Icon
                className={block('ActionSectionIcon', { red: true })}
                type="pause_circle_outline"
            />
            Logging out…
        </Fragment>;
    }

    render() {
        const { adminTimeout } = this.props;

        return <Modal
            className={block()}
            isOpen={adminTimeout.modal.isOpen}
            overlayClassName={block('Overlay')}
        >
            <Box title="Session expiring" className={block('Content')}>
                <TBody>
                    It looks like you’ve been inactive for several minutes. For security purposes,
                    we will automatically log you out of Proofpoint Isolation console.
                </TBody>

                <Actions className={block('Actions')}>
                    <div className={block('InfoBottomTextContainer')}>
                        {adminTimeout.timeLeft > 0 ? this.renderTimer() : this.renderTimeout()}
                    </div>

                    <Button
                        onClick={adminTimeout.cancel}
                        raised
                        primary
                        primaryGreen
                        fullWidth
                        disabled={adminTimeout.timeLeft < 1}
                    >STAY LOGGED IN</Button>
                </Actions>
            </Box>
        </Modal>;
    }
}

export default inject('adminTimeout')(observer(AdminActivityModal));
